// **************** Images ******************** //

import "../assets/logos/iiswe-logo-black.png";

// ********* Import CSS ******************** //

import "./form-popup.css";

// **************** Modal ******************** //

class FormPopup extends HTMLElement {
  connectedCallback() {

    this.innerHTML = `

      <div id="form-popup" class="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="staticBackdropLabel" aria-hidden="true">

        <div id="form-popup-box" class="modal-dialog modal-dialog-centered modal-md" role="document">

          <div class="modal-content">


          <!-- BEGIN modal-header -->

            <div class="modal-header">

              <img class="logo" src="iiswe-logo-black.png"/>

            </div>

          <!-- END modal-header -->


          <!-- BEGIN  modal-body -->

            <div class="modal-body">

              <p id="popup-main-text" class="general-text text-start"></p>

              <p id="popup-subtext" class="general-text text-start"></p>

              <p id="popup-contact" class="general-text text-start"></p>

            </div>

        <!-- END modal-body -->


        <!-- BEGIN modal-footer -->

            <div class="modal-footer">
              <button id="popup-close-btn" type="button" class="btn btn-secondary pt-1" data-bs-dismiss="modal">OK</button>
            </div>

       <!-- END modal-footer -->


          </div> <!-- modal-content -->

        </div> <!-- modal-dialog -->

      </div> <!-- modal -->
    `
  }
}

customElements.define('form-popup', FormPopup);


